import * as moment from 'moment';
import { CacheCarePlanItem } from './cacheCarePlanItem.class';
import { CacheContiguousVisits } from './cacheContiguousVisits.class';
import { CacheCoordinates } from './cacheCoordinates.class';
import { CacheExpenses } from './cacheExpenses.class';
import { CacheSignatureEntity } from './cacheSignatureEntity.class';
import { DateTimeFormat, MomentDefaultFormat } from './constantsExport.class';
import { MomentFormats } from 'src/shared/entities/momentFormats.class';
import { PatientGoal } from './cachePatientGoal.class';

export class CacheVisit {
    public ServiceOrderId: number
    public PatientId: number
    public MemberId: number
    public BusinessId: number
    public ServiceOrderIdString: string
    public ServiceTypeID: number
    public Duration: number
    public ArrivalTime: string
    public DepartureTime: string
    public AppointmentDate: string
    public Status: number
    public PatientFirstName: string
    public PatientLastName: string
    public WorkerFirstName: string
    public WorkerLastName: string
    public Latitude: number
    public Longitude: number
    public MobileCustomStatusName: string
    public MobileStatusColor: string
    public BillingFinanceId: string
    public Notes: string
    public Address1: string
    public City: string
    public PostalCode: string
    public CarePlanItems: CacheCarePlanItem[] = [];
    public PatientAddressList: CacheCoordinates[] = [];
    public PatientPrimaryPhone: string
    public PatientSecondaryPhone: string
    public ServiceTypeName: string
    public RelevantInformation: number
    // --------------------------------------------------------------- //
    public SignatureData: CacheSignatureEntity[] = [];
    public ExistingSignatureTypes: number[] = [];
    public NeedsSync: boolean = false;
    public IsCreatedByPhone: boolean = false;
    public ModifiedDate: Date;
    public ProvidedArrivalCoordinates: CacheCoordinates;
    public ProvidedDepartureCoordinates: CacheCoordinates;
    public HasVoiceConfirmation: boolean = false;

    public PatientConcerns: string;
    public PayableTime: number;
    public AuthorizedToRecordTrips: boolean = false;
    public TripCount: number;
    public PatientIsNotAvailable: boolean = false;
    public ErrandMiles: number;
    public ServiceIsConfirmed: boolean = false;
    public TimesAreConfirmed: boolean = false;
    public DisregardLocationWarnings: boolean = false;
    public IsMissedVisit: boolean = false;

    public AgencyName: String = null;
    public AgencyPhoneNumber: String = null;
    public IsMissed: boolean = false;
    public IsOnHold: boolean = false;
    public MissedVisitReason : string = null;
    public Expenses: CacheExpenses;

    public ContiguousVisits: CacheContiguousVisits[] = [];
    public showInfo: boolean = false;
    public emptyInfoItems: boolean = true;
    public emptyNotes: boolean = true;
    public StartFloatDate: string;
    public EndFloatDate: string;

    public PatientTime: string;
    public PatientZone: number;
    public RestartTimeArrival: number;
    public RestartTimeDeparture: number;
    public RestartSubmit: boolean = false;
    public NegativeTimeViolation: boolean = false;
    public PatientServiceOrderId: number = 0;
    public AllowOverlapAndTreatAsShift: boolean = false;

    public SyncFailed: boolean = false;

    public ArrivalClosureMethod: number = 0;
    public DepartureClosureMethod: number = 0;
    public ArrivalPhoneDate: string = "";
    public DeparturePhoneDate: string = "";
    public SistemPatientID2: number = 0;
    public IsFacility: boolean = false;
    public ClockRuleForVisit: number = 0;
    public RemainingAuthorizedHours : number = -1.0;
    public RemainingAuthorizedHoursTimePeriod : number = -1.0;
    public AllowToSkipWorkerSignature : boolean = false;
    public AllowToSkipPatientSignature : boolean = false;
    public HideErrandReportingOnMobileApp : boolean = false;
    public ArrivedDate: string = null;
    public DepartDate: string = null;
    
    public StatusReasonID: number = 0;
    public MissedVisitReasonID: number = 0;
    public RequireAuthorization : number = 0;
    public VisitBreakDuration : number = 0;
    public SetEVVTimesToScheduledTimes : boolean = false;
    public PatientGoals: PatientGoal[] = [];
    
    constructor(
        obj: CacheVisit
    ) {

        if (obj == null) {
            return;
        }

        this.ExistingSignatureTypes = obj.ExistingSignatureTypes;
        this.ServiceOrderId = obj.ServiceOrderId
        this.PatientId = obj.PatientId
        this.MemberId = obj.MemberId
        this.BusinessId = obj.BusinessId
        this.ServiceOrderIdString = obj.ServiceOrderIdString
        this.ServiceTypeID = obj.ServiceTypeID
        this.Duration = obj.Duration
        this.ArrivalTime = moment(obj.ArrivalTime, MomentFormats.momentFormats).format(DateTimeFormat);
        this.DepartureTime = moment(obj.DepartureTime, MomentFormats.momentFormats).format(DateTimeFormat);
        this.AppointmentDate = moment(obj.AppointmentDate, MomentFormats.momentFormats).format(DateTimeFormat);
        this.Status = obj.Status
        this.PatientFirstName = obj.PatientFirstName
        this.PatientLastName = obj.PatientLastName
        this.WorkerFirstName = obj.WorkerFirstName
        this.WorkerLastName = obj.WorkerLastName
        this.Latitude = obj.Latitude
        this.Longitude = obj.Longitude
        this.MobileCustomStatusName = obj.MobileCustomStatusName
        this.MobileStatusColor = obj.MobileStatusColor
        this.BillingFinanceId = obj.BillingFinanceId
        this.Notes = obj.Notes
        this.Address1 = obj.Address1
        this.City = obj.City
        this.PostalCode = obj.PostalCode
        this.CarePlanItems = obj.CarePlanItems
        this.PatientAddressList = obj.PatientAddressList;
        this.PatientPrimaryPhone = obj.PatientPrimaryPhone;
        this.PatientSecondaryPhone = obj.PatientSecondaryPhone;
        this.ServiceTypeName = obj.ServiceTypeName;
        this.ProvidedArrivalCoordinates = obj.ProvidedArrivalCoordinates;
        this.ProvidedDepartureCoordinates = obj.ProvidedDepartureCoordinates;
        this.NeedsSync = obj.NeedsSync ? obj.NeedsSync : false;
        this.ModifiedDate = obj.ModifiedDate ? obj.ModifiedDate : null;
        this.SignatureData = obj.SignatureData ? obj.SignatureData : [];
        this.PatientConcerns = obj.PatientConcerns ? obj.PatientConcerns : null;
        this.IsCreatedByPhone = obj.IsCreatedByPhone ? obj.IsCreatedByPhone : null;
        this.RelevantInformation = obj.RelevantInformation;
        this.PayableTime = obj.PayableTime;
        this.AuthorizedToRecordTrips = obj.AuthorizedToRecordTrips;
        this.TripCount = obj.TripCount;
        this.PatientIsNotAvailable = obj.PatientIsNotAvailable;
        this.HasVoiceConfirmation = obj.HasVoiceConfirmation;
        this.ErrandMiles = obj.ErrandMiles;
        this.ServiceIsConfirmed = obj.ServiceIsConfirmed;
        this.TimesAreConfirmed = obj.TimesAreConfirmed;
        this.AgencyName = obj.AgencyName;
        this.AgencyPhoneNumber = obj.AgencyPhoneNumber;
        this.IsMissed = obj.IsMissed ? obj.IsMissed : false;
        this.IsOnHold = obj.IsOnHold ? obj.IsOnHold : false;
        this.MissedVisitReason = obj.MissedVisitReason;
        this.Expenses = obj.Expenses;
        this.ContiguousVisits = obj.ContiguousVisits;
        this.StartFloatDate = moment(obj.StartFloatDate, MomentFormats.momentFormats).format(DateTimeFormat);
        this.EndFloatDate = moment(obj.EndFloatDate, MomentFormats.momentFormats).format(DateTimeFormat);
        this.PatientTime = obj.PatientTime;
        this.PatientZone = obj.PatientZone;
        this.RestartTimeArrival = obj.RestartTimeArrival;
        this.RestartTimeDeparture = obj.RestartTimeDeparture;
        this.NegativeTimeViolation = obj.NegativeTimeViolation;
        this.PatientServiceOrderId = obj.PatientServiceOrderId;
        this.AllowOverlapAndTreatAsShift = obj.AllowOverlapAndTreatAsShift;
        this.SyncFailed = obj.SyncFailed;
        this.ArrivalClosureMethod = obj.ArrivalClosureMethod;
        this.DepartureClosureMethod = obj.DepartureClosureMethod;
        this.ArrivalPhoneDate = obj.ArrivalPhoneDate;
        this.DeparturePhoneDate = obj.DeparturePhoneDate;
        this.SistemPatientID2 = obj.SistemPatientID2;
        this.IsFacility = obj.IsFacility;
        this.ClockRuleForVisit = obj.ClockRuleForVisit;
        this.AllowToSkipPatientSignature = obj.AllowToSkipPatientSignature;
        this.AllowToSkipWorkerSignature = obj.AllowToSkipWorkerSignature;
        this.HideErrandReportingOnMobileApp = obj.HideErrandReportingOnMobileApp;
        this.RemainingAuthorizedHours = obj.RemainingAuthorizedHours;
        this.RemainingAuthorizedHoursTimePeriod = obj.RemainingAuthorizedHoursTimePeriod;
        this.ArrivedDate = obj.ArrivedDate == '01/01/0001 00:00:00' ? null : moment(obj.ArrivedDate, MomentFormats.momentFormats).format(DateTimeFormat);
        this.DepartDate =  obj.DepartDate == '01/01/0001 00:00:00' ? null : moment(obj.DepartDate, MomentFormats.momentFormats).format(DateTimeFormat);
        this.RequireAuthorization = obj.RequireAuthorization;
        this.VisitBreakDuration = obj.VisitBreakDuration;
        this.SetEVVTimesToScheduledTimes = obj.SetEVVTimesToScheduledTimes;
        this.PatientGoals = obj.PatientGoals;

    }
}